import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ICollaborator } from "src/app/models/Interfaces/Collaborators/CollaboratorsResponseInterface";
import { ResponseDataInterfaces } from "src/app/models/Interfaces/ResponseDataInterfaces";
import { environment } from "src/environments/environment";
const endPoint = `${environment.apiUrlCap}/api/collaborators`;

@Injectable({
  providedIn: "root",
})
export class CollaboratorService {
  constructor(private http: HttpClient) {}

  GetByCurp(curp: string): Observable<ResponseDataInterfaces<ICollaborator>> {
    return this.http.get<ResponseDataInterfaces<ICollaborator>>(
      `${endPoint}/curp/${curp}`
    );
  }

  GetByEmail(
    email: string
  ): Observable<ResponseDataInterfaces<ICollaborator | ICollaborator[]>> {
    return this.http.get<
      ResponseDataInterfaces<ICollaborator | ICollaborator[]>
    >(`${endPoint}/email/${email}`);
  }

  GetByPersonNumber(
    personNumber: string
  ): Observable<ResponseDataInterfaces<ICollaborator>> {
    return this.http.get<ResponseDataInterfaces<ICollaborator>>(
      `${endPoint}/personNumber/${personNumber}`
    );
  }
}
